import IconButton from "@mui/material/IconButton";
import Close from "@mui/icons-material/Close";

const CloseIcon = ({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled?: boolean;
}) => {
  return (
    <IconButton
      disabled={disabled}
      style={{
        height: 22,
        width: 22,
        backgroundColor: "#0F2C52",
        borderRadius: 11,
        color: "white",
      }}
      onClick={onClick}
    >
      <Close
        style={{
          fontSize: 18,
        }}
      />
    </IconButton>
  );
};

export default CloseIcon;
